import { useEffect, useState } from 'react';

const defaultDebounceMs = 1000;

export function useDebounce<T>(value: T, delay = defaultDebounceMs): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
}
